module.exports = __webpack_public_path__ + "static/media/Ivory Coast.11bbac3c.png";